require('./comparativeBarComposed.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
// @ components
const { ComparativeBarSimple } = require('components/comparativeBarSimple/comparativeBarSimple');
// @ constants
const defaultFirstColor = '#0070D9'; // $science-blue
const defaultSecondColor = '#2A3750'; // $pickled-bluedwood-color

const ComparativeBarComposed = props => {
    const { firstValue, secondValue, totalValue, firstColor, secondColor, height } = props;
    const firstBar = (
        <ComparativeBarSimple firstValue={firstValue} totalValue={totalValue} height={height} color={firstColor} />
    );
    const secondBar = (
        <ComparativeBarSimple
            firstValue={firstValue + secondValue}
            totalValue={totalValue}
            height={height}
            color={secondColor}
        />
    );
    let baseComponentStyles = {
        height: height + 'px',
    };

    return (
        <div className="comparative-bar-composed" style={baseComponentStyles}>
            <div className="comparative-bar-composed__wrapper">{firstBar}</div>
            <div className="comparative-bar-composed__wrapper">{secondBar}</div>
        </div>
    );
};

ComparativeBarComposed.propTypes = {
    firstColor: PropTypes.string,
    firstValue: PropTypes.string,
    height: PropTypes.number,
    secondColor: PropTypes.string,
    secondValue: PropTypes.number,
    totalValue: PropTypes.number,
};

ComparativeBarComposed.defaultProps = {
    firstColor: defaultFirstColor,
    firstValue: '0',
    height: 6,
    secondColor: defaultSecondColor,
    secondValue: 0,
    totalValue: 0,
};

export { ComparativeBarComposed };
